import { Filter } from '@/components/Elements/Filter';
import { FieldWrapper } from '@/components/Form/FieldWrapper';
import { FilterLocationSelect } from '@/features/countries';

const tableFilters: { name: string; options: { label: string; value: string }[] }[] = [
  {
    name: 'type',
    options: [
      {
        label: '',
        value: '',
      },
      {
        label: 'employee',
        value: 'employee',
      },
      {
        label: 'contractor',
        value: 'contractor',
      },
    ],
  },
  {
    name: 'status',
    options: [
      {
        label: '',
        value: '',
      },
      {
        label: 'active',
        value: 'active',
      },
      {
        label: 'pending',
        value: 'pending',
      },
      {
        label: 'filled',
        value: 'filled',
      },
      {
        label: 'terminated',
        value: 'terminated',
      },
    ],
  },
];

export const Filters = () => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {tableFilters.map((filter) => (
        <div className="col-span-1" key={filter.name}>
          <FieldWrapper label={filter.name}>
            <Filter name={filter.name} options={filter.options} />
          </FieldWrapper>
        </div>
      ))}
      <FieldWrapper label="location">
        <FilterLocationSelect />
      </FieldWrapper>
    </div>
  );
};
